var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack4Solid08({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8 1 0.64 6.35 3.45 15 12.55 15 15.36 6.35 8 1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7,8.53a1.74,1.74,0,0,1-.85-.68,1.71,1.71,0,0,1-.26-.94A1.9,1.9,0,0,1,6.2,5.45,2.47,2.47,0,0,1,8,4.88a2.47,2.47,0,0,1,1.74.57,1.88,1.88,0,0,1,.62,1.46,1.7,1.7,0,0,1-.28,1,1.78,1.78,0,0,1-.8.65,2.16,2.16,0,0,1,1,.77,2,2,0,0,1,.34,1.17,2.38,2.38,0,0,1-.69,1.77A2.54,2.54,0,0,1,8,12.92a2.83,2.83,0,0,1-1.79-.56,2.21,2.21,0,0,1-.84-1.83A2.25,2.25,0,0,1,5.7,9.36,2.13,2.13,0,0,1,6.7,8.53Zm.18,1.86a1.4,1.4,0,0,0,.31,1,1.06,1.06,0,0,0,.8.35,1,1,0,0,0,.78-.34,1.39,1.39,0,0,0,.3-1,1.25,1.25,0,0,0-.31-.89A1,1,0,0,0,8,9.18a.94.94,0,0,0-.82.38A1.33,1.33,0,0,0,6.88,10.39ZM7,7a1,1,0,0,0,.26.71A.92.92,0,0,0,8,8a1,1,0,0,0,.69-.25A1,1,0,0,0,8.89,7,.88.88,0,0,0,8,6.07.89.89,0,0,0,7,7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack4Solid08);
export default __webpack_public_path__ + "static/media/Symbolpack_4_solid_08.291395cc400aa6b5fce5732fef523992.svg";
export { ForwardRef as ReactComponent };